import { debounce } from '@core/utilities/lodash-utils';

type RefineWrapper = <TValue>(refine: (value: TValue) => void, value: TValue) => void;
const refineWrapper: RefineWrapper = (refine, value) => refine(value);
const debounceTime = 1000;

export const createDebouncedRefine = () => debounce(refineWrapper, debounceTime);
